export enum FeatureFlagEnum {
  AdminPanelV2 = 'admin-panel-v2',
  chargesWithCheckout = 'charges-with-checkout',
  PartialPaymentPermission = 'partial-payment-permission',
  ResetAccountPermission = 'reset-account-permission',
  ActivateSubscriptionZatca = 'activate-subscription-zatca',
}
